/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// ./src/js/bundles/layout/visually-experiments.ts

/*
 * Standalone layout entry that hands Visually the callback it reports
 * experiences to.
 *
 * Visually's SDK calls `window.vslyOnExperienceApplied` as it applies each
 * experience, and it does not replay experiences it applied before the
 * callback existed. So the callback has to exist before the SDK runs. That is
 * why this is its own bundle loaded synchronously ahead of the SDK rather than
 * a part of the deferred theme bundle, which would run too late.
 *
 * The SDK can also call it again later on the same page, for example after a
 * click or when targeting changes, so a repeat has to be harmless. The store
 * ignores a variant it already holds.
 *
 * It queues onto the plain `window.nutsExperiments` array that
 * `useNutsExperiments()` replays into the store, so it imports nothing and
 * the store's code stays out of the critical path. If the store already
 * exists, `push` on it takes the same report. The store validates it.
 *
 * Keep this entry dependency-free; it blocks parsing on every page.
 */

function readField(report, field) {
  return Reflect.get(report, field);
}
window.vslyOnExperienceApplied = function (experience) {
  if (!experience || _typeof(experience) !== 'object') return;
  (window.nutsExperiments = window.nutsExperiments || []).push({
    experienceId: readField(experience, 'experienceId'),
    experienceName: readField(experience, 'experienceName'),
    variantId: readField(experience, 'variantId'),
    variantName: readField(experience, 'variantName')
  });
};

/******/ })()
;